import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  jwtHelperService = new JwtHelperService();
  
  constructor(private router:Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
   
   
   let myToken = localStorage.getItem('token')
   let decodedToken = this.jwtHelperService.decodeToken(myToken);

      if(decodedToken.role =='Admin'){
        
      }
      else{
        this.router.navigate(['/forbidden'])
      }
      return true;
  }

  
}
